import React from 'react'
import LoadingCell from './Loaders/LoadingCell';
import { ClinicTableRow } from './types';
import { formatDateTimeHumanFriendly } from '../../../../utils/formatters';
import { ClinicFromList } from '../../types';

export const headers: ClinicTableRow = {
  view: {
    name: 'Clinic Name',
    associatedTreatments: 'Attached treatments',
    description: 'Description',
    dateModified: 'Date modified'
  },
  headers: true
};

export const prepareLoadingData = (rowsPerPage: number) => {
  return Array.from({ length: rowsPerPage }).reduce<ClinicTableRow[]>(
    data => {
      data.push({
        view: {
          name: <LoadingCell />,
          associatedTreatments: <LoadingCell />,
          dateModified: <LoadingCell />,
          description: <LoadingCell />
        }
      });
      return data;
    },
    [headers]
  );
};

export const convertClinicsToTable = (clinics: ClinicFromList[]) => {
  if (!clinics) {
    return [];
  }

  return clinics.reduce(
    (data, clinic) => {
      const { _id, name, description, date_created, date_updated } = clinic;

      const dateModified = date_created || date_updated;

      data.push({
        view: {
          name,
          associatedTreatments: 'None',
          dateModified: getUnixHumanFriendly(dateModified),
          description
        },
        ID: String(_id),
        route: 'clinics'
      });

      return data;
    },
    [headers]
  );
};

function getUnixHumanFriendly(unix) {
  return formatDateTimeHumanFriendly(unix * 1000);
}